import request from "./base";
const path = "/api/tracking";

export default {
  getCaptchaTracking: function () {
    return request().get(path + "/captcha");
  }
};
